import { api } from "@/api";

export interface PostLoginResponse {
  success: boolean;
}

export async function postLoginUser(userPrincipalName: string): Promise<PostLoginResponse> {
  const res = await api.postLogin(userPrincipalName);
  return res as PostLoginResponse;
}

export async function getFluxxUserId(userPrincipalName: string): Promise<string> {
  const res = await api.getFluxxUserId(userPrincipalName);
  return res as string;
}
